module.exports = __webpack_public_path__ + "img/st.d0a56dbb.svg";